import { AxiosResponse } from "axios";
import api from "../../utils/api";
import routes from "../../utils/apiRoutes.json";

export function getUserRating(setRating: Function): Promise<AxiosResponse<any>> {
    const path: string = routes.rating;
    
    return api.get(
        path,
    ).then((response) => {
        const rating : any = response.data.data;
        setRating(rating);
        return response;
    },
    ).catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        return err;
    });
}